// src/Components/MedicSearchForm/WorkNumberDisplay/WorkNumberDisplay.tsx

import React from 'react';
import { FaWhatsapp, FaTelegramPlane, FaPhoneAlt } from 'react-icons/fa';
import type { ContactPoint } from '../../../Types/schema-helpers';
import './WorkNumberDisplay.css';

interface WorkNumberWidgetProps {
  contacts?: ContactPoint[] | null | undefined;
}

const sanitizeNumber = (num: string): string => num.replace(/\D/g, '');

const WorkNumberWidget: React.FC<WorkNumberWidgetProps> = ({ contacts }) => {
  if (!contacts || !Array.isArray(contacts) || contacts.length === 0) {
    return null;
  }

  return (
    <div className="contact-info-wrapper mt-2">
      {contacts.map((contact, index) => {
        const cleanNumber = sanitizeNumber(contact.number);

        return (
          <div key={index} className="d-flex align-items-center mb-2 gap-3">
            <div className="contact-main">
              <a
                href={`tel:${cleanNumber}`}
                className="text-decoration-none text-dark fw-bold"
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              >
                <FaPhoneAlt className="me-2 text-secondary" size={14} />
                {contact.number}
                {contact.extension && (
                  <span className="ms-1 text-muted small">Ext: {contact.extension}</span>
                )}
              </a>
              {contact.label && (
                <div
                  className="text-muted"
                  style={{ fontSize: '10px', textTransform: 'uppercase' }}
                >
                  {contact.label}
                </div>
              )}
            </div>

            <div className="contact-actions d-flex gap-2">
              {contact.is_whatsapp && (
                <a
                  href={`https://wa.me/${cleanNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success"
                  title="WhatsApp"
                  onClick={(e: React.MouseEvent) => e.stopPropagation()}
                >
                  <FaWhatsapp size={20} />
                </a>
              )}
              {contact.is_telegram && (
                <a
                  href={`https://t.me/+${cleanNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                  title="Telegram"
                  onClick={(e: React.MouseEvent) => e.stopPropagation()}
                >
                  <FaTelegramPlane size={20} />
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WorkNumberWidget;